import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Input from '@material-ui/core/Input'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import { etiquetaService } from '../../aplicacion/addEtiqueta'
import { destinatarioService } from '../../aplicacion/addDestinatario'
import { Select, MenuItem } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Grid from '@material-ui/core/Grid'
// import SnackbarContent from '@material-ui/core/SnackbarContent'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '30px',
    width: '85%',
    // display: 'flex',
    // justifyContent: 'center',
    // justifyContent: 'space-around',
    // alignItems: 'flex-end',
  },
  gritNota: {
    justifyContent: 'center',
  },
  nota: {
    textAlign: 'justify',
    maxWidth: 600,
    borderRadius: '35px 0px 35px 0px',
    border: '2px outset #FFF278',
    background: '#FFFACC',
    // color: '#690066',
    color: '#2E002F',
    fontSize: '14px',
    padding: '20px',
    // fontStyle: 'oblique ',
  },

  grid: {
    display: 'flex',
    // justifyContent: 'space-around',
    alignItems: 'flex-end',
    justifyItems: 'stretch',
  },
  icon: {
    paddingLeft: '12px',
    paddingRight: '12px',
    paddingBottom: '0px',
  },
}))

export const Buscador = ({ onSearch, onTagSelected, onDescriptorSelected }) => {
  const classes = useStyles()
  const [destOptions, setDestOptions] = useState([])
  const [tagOptions, setTagOptions] = useState([])
  const [selectedTag, setSelectedTag] = useState('')
  const [selectedDest, setSelectedDest] = useState('')
  const [search, setSearch] = useState()

  useEffect(() => {
    const fetchData = async () => {
      const a = await etiquetaService.getAll()
      setTagOptions(a)
      const b = await destinatarioService.getAll()
      setDestOptions(b)
    }
    fetchData()
  }, [])

  const onSearchChange = value => {
    onSearch(value)
    setSearch(value)
    setSelectedDest('')
    setSelectedTag('')
  }

  const onChangeSelectedTag = value => {
    setSelectedTag(value.target.value)
    onTagSelected(value.target.value)
  }

  const clearValuesDes = () => {
    setSearch('')
    setSelectedTag('')
  }

  const clearValuesTag = () => {
    setSearch('')
    setSelectedDest('')
  }

  const onChangeSelectedDes = value => {
    setSelectedDest(value.target.value)
    onDescriptorSelected(value.target.value)
  }

  return (
    <div className={classes.root}>
      <>
        <Grid container className={classes.gritNota}>
          <Grid item xs={12} sm={12} className={classes.nota}>
            {/* <div > */}
            Desde Acción Explorer estamos reuniendo una serie de recursos que nos parecen de utilidad para estos días.
            Además, podéis filtrar los recursos en función del nombre, el público al que va dirigido o las etiquetas.
            {/* </div> */}
          </Grid>
        </Grid>
      </>
      {'\n'}
      <Grid container spacing={2} className={classes.grid}>
        <Grid item xs={12} sm={4}>
          <div>
            <IconButton type="submit" aria-label="search" className={classes.icon} disabled>
              <SearchIcon />
            </IconButton>
            {'   '}
            <Input
              // fullWidth
              className={classes.formControl}
              style={{ width: 300 }}
              value={search}
              placeholder="Filtrar por nombre..."
              onChange={values => onSearchChange(values.target.value)}
            />
          </div>
        </Grid>
        {'      '}
        <Grid item xs={12} sm={4}>
          <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">Filtrar por destinatario...</InputLabel>
            <Select
              style={{ width: 300 }}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              onClose={clearValuesDes}
              // placeholder="Filtrar por destinatario..."
              value={selectedDest}
              onChange={onChangeSelectedDes}
            >
              <MenuItem value="">
                <em>Todos los destinatarios</em>
              </MenuItem>
              {destOptions.map(tag => (
                <MenuItem key={tag.title} value={tag.title}>
                  {tag.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {'      '}
        <Grid item xs={12} sm={4}>
          <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">Filtrar por etiqueta...</InputLabel>
            <Select
              style={{ width: 300 }}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedTag}
              onClose={clearValuesTag}
              onChange={onChangeSelectedTag}
            >
              <MenuItem value="">
                <em>Cualquier etiqueta</em>
              </MenuItem>
              {tagOptions.map(tag => (
                <MenuItem key={tag.title} value={tag.title}>
                  {tag.title}{' '}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </div>
  )
}
